/* eslint-disable no-unused-vars */
/* eslint-disable  max-len */
/* eslint-disable camelcase */
/* eslint-disable prefer-destructuring */

import React from 'react';
import { connect } from 'react-redux';
import ReactToPrint from 'react-to-print';

import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';
import { formatDayToYearLong } from 'utils/date/format.util';

import ComponentToPrint from 'reports/Common/ComponentToPring';
import { calculateTotalsOnProductSalesData, calculateTotalsOnServiceSalesData } from 'reports/sales.bl';
import AppointmentsTable from 'reports/Staffkpi/AppointmentsTable';
import BookingValByServiceTable from 'reports/Staffkpi/BookingValByServiceTable';
import ClientsTable from 'reports/Staffkpi/ClientsTable';
import CountOfServicesByCategoryTable from 'reports/Staffkpi/CountOfServicesByCategoryTable';
import CountOfServicesTable from 'reports/Staffkpi/CountOfServicesTable';
import ExistingClientsTable from 'reports/Staffkpi/ExistingClientsTable';
import NewClientsTable from 'reports/Staffkpi/NewClientsTable';
import StaffPerformanceTable from 'reports/Staffkpi/StaffPerformanceTable';
import { convertStylistsMapsToStylistTableData } from 'reports/utils';
const RENDER_TABLE = false;

const ReportsProps = [
  'salonHoursReport',
  'salesReport',
  'uniqueVisitsReport',
  'rebookingReport',
  'visitFrequencyReport',
  'appointmentsReport',
  'newClientsReport',
];

class StaffkpiLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.componentRef = React.createRef();
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    if (this.props.currentTable === 'Clients') {
      window.scrollTo(0, 1300);
    }
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    const currencyAbbr = this.props.currency;

    let revenueData;
    let totalBookings = 1;
    if (this.checkIfAllDataIsLoaded()) {
      const stylistGroup = this.props.salesReport.lastRequestResponse.stylist_group;

      const nameServicesTotalPriceMap = {};
      stylistGroup.forEach((stylist) => {
        nameServicesTotalPriceMap[stylist.name] = calculateTotalsOnServiceSalesData(stylist.services);
      });
      const nameProductsTotalPriceMap = {};
      stylistGroup.forEach((stylist) => {
        nameProductsTotalPriceMap[stylist.name] = calculateTotalsOnProductSalesData(stylist.products);
      });
      if (this.props.rebookingReport && this.props.rebookingReport.lastRequestResponse) {
        totalBookings = this.props.rebookingReport.lastRequestResponse.total_appointments;
      }
      revenueData = convertStylistsMapsToStylistTableData(
        nameServicesTotalPriceMap,
        nameProductsTotalPriceMap,
        currencyAbbr,
      );
    }
    return (
      <div className="has-protipbox">
        <div className="performance p3">
          {!this.checkIfAllDataIsLoaded() && (
            <div className="spinner-container">
              <div className="load-spinner" />
              <div className="spinner-text">
                Loading LOTS of financial and booking data{' '}
                <span role="img" aria-labelledby="nerd face emoji">
                  🤓
                </span>
                <br />
                Please wait...
              </div>
            </div>
          )}
          {this.checkIfAllDataIsLoaded() && revenueData && (
            <React.Fragment>
              <div className="banner default full-width kpi">
                <div style={{ width: '100%' }}>
                  <div className="cfix relative">
                    <span className="img-emoji-1" role="img" aria-labelledby="lamp">
                      💡
                    </span>
                    <div className="text">
                      <strong>Pro tip:</strong>
                      These reports are based on the value of bookings in your Slick diary. To see actual sales based on
                      checked out transactions, head to the Revenue tab
                    </div>
                  </div>
                  <div className="cfix relative">
                    <span className="img-emoji-2" role="img" aria-labelledby="lamp">
                      💡
                    </span>
                    <div className="text">
                      <strong>Pro tip:</strong>
                      Select a future date range to see projections of your expected takings
                    </div>
                  </div>
                </div>
                <div className="link">
                  <a
                    href="https://help.getslick.com/en/articles/2057416-overview-of-slick-salon-reports"
                    alt="Heed help"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Need Help?
                  </a>
                  <ReactToPrint
                    trigger={() => <button className="btn-print-pdf-reports">Print PDF</button>}
                    content={() => this.componentRef.current}
                  />
                </div>
              </div>
              <div style={{ marginTop: '18px' }} />

              <ComponentToPrint ref={this.componentRef} componentRef>
                {RENDER_TABLE && (
                  <div>
                    <StaffPerformanceTable
                      startDate={formatDayToYearLong(this.props.uniqueVisitsReport.start_date)}
                      endDate={formatDayToYearLong(this.props.uniqueVisitsReport.end_date)}
                    />
                    <AppointmentsTable
                      startDate={formatDayToYearLong(this.props.uniqueVisitsReport.start_date)}
                      endDate={formatDayToYearLong(this.props.uniqueVisitsReport.end_date)}
                      appointmentsReport={this.props.appointmentsReport.lastRequestResponse}
                      stylistIDInCalendarOrder={this.props.stylistIDInCalendarOrder}
                      salonVatRate={this.props.salonVatRate}
                    />

                    <ClientsTable
                      startDate={formatDayToYearLong(this.props.uniqueVisitsReport.start_date)}
                      endDate={formatDayToYearLong(this.props.uniqueVisitsReport.end_date)}
                      uniqueVisitsReport={this.props.uniqueVisitsReport.lastRequestResponse}
                      rebookingReport={this.props.rebookingReport.lastRequestResponse}
                      visitFrequencyReport={this.props.visitFrequencyReport.lastRequestResponse}
                      stylistIDInCalendarOrder={this.props.stylistIDInCalendarOrder}
                      stylistsRequestsReport={this.props.stylistsRequestsReport}
                    />
                    <NewClientsTable
                      startDate={formatDayToYearLong(this.props.uniqueVisitsReport.start_date)}
                      endDate={formatDayToYearLong(this.props.uniqueVisitsReport.end_date)}
                      newClientsReport={this.props.newClientsReport.lastRequestResponse}
                      stylistIDInCalendarOrder={this.props.stylistIDInCalendarOrder}
                      salonVatRate={this.props.salonVatRate}
                    />
                    <ExistingClientsTable
                      startDate={formatDayToYearLong(this.props.uniqueVisitsReport.start_date)}
                      endDate={formatDayToYearLong(this.props.uniqueVisitsReport.end_date)}
                      newClientsReport={this.props.newClientsReport.lastRequestResponse}
                      appointmentsReport={this.props.appointmentsReport.lastRequestResponse}
                      rebookingReport={this.props.rebookingReport.lastRequestResponse}
                      stylistIDInCalendarOrder={this.props.stylistIDInCalendarOrder}
                    />
                  </div>
                )}
                <CountOfServicesByCategoryTable
                  startDate={formatDayToYearLong(this.props.uniqueVisitsReport.start_date)}
                  endDate={formatDayToYearLong(this.props.uniqueVisitsReport.end_date)}
                  stylistPerformedCategoriesReport={this.props.stylistPerformedCategoriesReport.lastRequestResponse}
                />

                <CountOfServicesTable
                  startDate={formatDayToYearLong(this.props.uniqueVisitsReport.start_date)}
                  endDate={formatDayToYearLong(this.props.uniqueVisitsReport.end_date)}
                />

                <BookingValByServiceTable
                  startDate={formatDayToYearLong(this.props.uniqueVisitsReport.start_date)}
                  endDate={formatDayToYearLong(this.props.uniqueVisitsReport.end_date)}
                  salonVatRate={this.props.salonVatRate}
                />
              </ComponentToPrint>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  salonId: state?.currentSalon?.id,
  clientList: state?.clientCommunications?.clientList,
  salesReport: state?.reports?.salesReport,
  salonHoursReport: state?.reports?.salonHoursReport,
  uniqueVisitsReport: state?.reports?.uniqueVisitsReport,
  rebookingReport: state?.reports?.rebookingReport,
  uniqueClientsReport: state?.reports?.uniqueClientsReport,
  visitFrequencyReport: state?.reports?.visitFrequencyReport,
  appointmentsReport: state?.reports?.appointmentsReport,
  stylistList: state?.currentSalon?.stylistList,
  stylistIDInCalendarOrder: state?.reports?.stylistIDInCalendarOrder,
  stylistsRequestsReport: state?.reports?.stylistsRequestsReport,
  newClientsReport: state?.reports?.newClientsReport,
  salonVatRate: state?.reports?.salonVatRate,
  currentTable: state?.reports?.currentTable,
  stylistPerformedCategoriesReport: state?.reports?.stylistPerformedCategoriesReport,
  currency: selectCurrentSalonCurrency(state),
});

const StaffkpiLayoutHoc = connect(mapStateToProps)(StaffkpiLayout);

export default StaffkpiLayoutHoc;
